import { createContext, useContext } from 'react';

import type { UseGatewayClaimBeaconResult } from './useGatewayClaimBeacon';

/**
 * Gateway Claim Context
 *
 * Exposes the app-wide beacon: its claim code, the Local Network Access
 * permission state, whatever it has discovered, and the controls to arm it and
 * boost it to a foreground scan. Everything the scan panel needs, so that a
 * page-level panel and the background watcher share one code and one session.
 */
export type GatewayClaimContextType = UseGatewayClaimBeaconResult;

export const GatewayClaimContext = createContext<GatewayClaimContextType | undefined>(undefined);

export function useGatewayClaim() {
  const context = useContext(GatewayClaimContext);
  if (!context) {
    throw new Error('useGatewayClaim must be used within GatewayClaimProvider');
  }
  return context;
}
